export class UserLoginModel{
    docType: string = "";
    docNumber: string = "";
    password: string = "";
}

export class UserLoggedResponse{
    email: string = "";
    nombre: string = "";
    primerApellido: string = "";
    opciones: any = null;
    roles: UserRolResponde[] = [];  
    document: string = "";
}   

export class UserRolResponde{
    claveRol: string = "";
    nombreRol: string = "";
}
    
export class TermsAndHDResponde{
    VTYCVIGENTE: string = "";
    VTYCACEPTA: string = "";
    VHDVIGENTE: string = "";
    VHDACEPTA: string = "";
}